export default "__VITE_PUBLIC_ASSET__844e0b87__"